import React, { useState } from 'react';
import truncate from 'lodash/truncate';

import ListResource from './ListResource.jsx';
import ListCompSelect from './ListCompSelect.jsx';
import Html from '../../../commons/components/Html.jsx';

const api = 'api/quiz/scores/questions';

function replaceMediaTags(html) {
  if (!html) return '';
  let result = html.replace(/<iframe[\s\S]*?<\/iframe>/gi, '[影片]');
  result = result.replace(/<img[\s\S]*?>/gi, '[圖片]');
  return result;
}

const ListScores = () => {
  const [compFilter, setCompFilter] = useState({});

  return (
    <ListResource
      {...{
        // searchable: true,
        api,
        sort: { 'question.qSetCode': 1 },
        filter: { ...compFilter },
        actions: {
          find: false,
          create: false,
          remove: false,
          fileExport: 'export',
        },
        ctrls: [
          <ListCompSelect
            key={0}
            value={compFilter}
            onChange={setCompFilter}
            questionSet
          />,
        ],
        cols: [
          {
            key: 'question.qSetCode',
            children: 'Subject',
            sortable: true,
          },
          {
            key: 'question.refCode',
            children: 'Code',
            sortable: true,
          },
          {
            key: 'question.question',
            children: 'Question',
            getter: (v) => {
              console.log({ v, truncated: truncate(replaceMediaTags(v), 15) });
              return <Html>{replaceMediaTags(v)}</Html>;
              return <Html>{truncate(replaceMediaTags(v), 15)}</Html>;
            },
          },
          {
            key: 'answered',
            children: (
              <span title="Number of times the question has been drawn randomly">
                Picked *
              </span>
            ),
            sortable: true,
          },
          {
            key: 'isCorrect',
            children: 'Correct',
            sortable: true,
          },
          {
            key: 'correctPct',
            children: 'Correct %',
            sortable: true,
            getter: (v) => (v !== 'na' ? `${Math.round(v * 100 * 100) / 100}%` : 'N/A'),
          },
        ],
      }}
    />
  );
};

export default ListScores;
